import React from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';
import Animated, { useSharedValue, useAnimatedStyle, withTiming } from 'react-native-reanimated';
import theme from '../theme';

export default function AppButton({ title, onPress, style, color }: any){
  const scale = useSharedValue(1);
  const aStyle = useAnimatedStyle<any>(()=>({ transform: [{ scale: withTiming(scale.value, { duration: 100 }) }] }));
  const bg = color || theme.colors.primary;
  return (
    <Pressable onPressIn={()=>{ scale.value = 0.96; }} onPressOut={()=>{ scale.value = 1; }} onPress={onPress}>
      <Animated.View style={[styles.btn, { backgroundColor: bg }, style, aStyle]}>
        <Text style={styles.txt}>{title}</Text>
      </Animated.View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  btn: { paddingVertical: 12, paddingHorizontal: 18, borderRadius: 12, alignItems: 'center', justifyContent: 'center' },
  txt: { color: theme.colors.textPrimary, fontWeight: '700' }
});
